<div class="w-full h-full flex flex-col">
  <app-lesson-header
    icon="bi-file-pdf"
    iconColor="text-red-500"
    [title]="lesson.title"
    [subtitle]="lesson.description"
  >
  </app-lesson-header>

  <div class="flex-1 min-h-0 overflow-y-auto p-6">
    <form
      [formGroup]="pdfForm"
      (ngSubmit)="onSave()"
      class="flex flex-col gap-6 h-full"
    >
      <div class="space-y-4">
        <div>
          <label
            for="pdf-title"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            Título da Lição *
          </label>
          <input
            type="text"
            id="pdf-title"
            formControlName="title"
            class="form-field-control placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('title')"
            placeholder="Digite o título da lição"
          />
          @if (isFieldInvalid('title')) {
          <p class="mt-1 text-sm text-red-600">{{ getFieldError('title') }}</p>
          }
        </div>

        <div>
          <label
            for="pdf-description"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            Descrição *
          </label>
          <textarea
            id="pdf-description"
            formControlName="description"
            rows="4"
            class="form-field-textarea placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('description')"
            placeholder="Digite a descrição da lição"
          ></textarea>
          @if (isFieldInvalid('description')) {
          <p class="mt-1 text-sm text-red-600">
            {{ getFieldError('description') }}
          </p>
          }
        </div>

        <div>
          <label
            for="pdf-url"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            URL do PDF *
          </label>
          <input
            type="url"
            id="pdf-url"
            formControlName="pdfUrl"
            class="form-field-control placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('pdfUrl')"
            placeholder="https://exemplo.com/documento.pdf"
          />
          @if (isFieldInvalid('pdfUrl')) {
          <p class="mt-1 text-sm text-red-600">{{ getFieldError('pdfUrl') }}</p>
          }
          <p class="mt-1 text-xs text-blue-800">
            URL do arquivo PDF a ser exibido
          </p>
        </div>

        <div>
          <label
            for="pdf-duration"
            class="mb-1 block text-sm font-medium text-gray-700"
          >
            Duração (minutos) *
          </label>
          <input
            type="number"
            id="pdf-duration"
            formControlName="duration"
            min="1"
            class="form-field-control placeholder-gray-500"
            [class.border-red-500]="isFieldInvalid('duration')"
            placeholder="0"
          />
          @if (isFieldInvalid('duration')) {
          <p class="mt-1 text-sm text-red-600">
            {{ getFieldError('duration') }}
          </p>
          }
        </div>
      </div>

      <div
        class="form-actions flex items-center justify-between border-t border-gray-200 pt-4"
      >
        <button type="button" class="btn-danger" (click)="onDelete()">
          <i class="bi bi-trash mr-2"></i>
          Excluir Lição
        </button>
        <button type="submit" class="btn-primary" [disabled]="pdfForm.invalid">
          Salvar Alterações
        </button>
      </div>
    </form>
  </div>
</div>
